import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNeckGlyphSecondary from './svgs/NeckGlyphSecondary.js';
import SvgNeckGlyph from './svgs/NeckGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var neckGlyph = (props => useIcon(SvgNeckGlyph, SvgNeckGlyphSecondary, props));

export { neckGlyph as default };
